export enum enumDLIDocumentDescription {
  'Shamwari Check',
  'Proof of Address',
  'Proof of Income',
  'PEP&Terrorist Check',
  'Client ID',
  'Application',
  'CellBank Service Application',
  'DHA Check',
  'Card Replacement',
  'Termination Of Free Funeral Cover',
  'SureCard Account Classification Upgrade',
  'Passport',
  'Work Permit',
  'Birth Certificate',
  'Temporary ID',
  'Temporary Passport',
  'Account Pack',
  'Account Pack Card Replacement',
  'Funeral Benefit Application',
  'Funeral Policy Certificate',
  'Unknown',
  'Card Signature',
  'ID Verification',
  'PEP & Terrorist Prv',
  'Salary Instruction',
  'Asylum Seeker Permi',
  'Application Bus',
  'Resolution',
  'Bookkeeper Letter',
  'Tax Clear Cert',
  'Proof of Bus Add',
  'World Check Bus',
  'CIPC Reg Ver',
  'ID Bus Client',
  'Proof of Res Bus',
  'KYC Business',
  'Online Banking App',
  'Limit Increase Bus',
  'Reg Cert COR14.3',
  'Memo Inc COR15.1A',
  'Notice Inc COR14.1',
  'Passport Check',
  'Refugee Status Perm',
  'Dormancy React',
  'Indemnity Form',
  'PEP Report Form',
  'Additional Document',
  'Client Interview',
  'Terms & Conditions',
  'Letter of Authority',
  'Trust Deed',
  'Application T&C',
  'Historic Document',
  'Mobile Banking Serv',
  'MCT Form',
  'CPB DHA Verificatio',
  'VAT Document',
  'CIPC Check',
  'CK 1',
  'CK 2',
  'Annexure C',
  'SASSA Confirmation',
  'SASSA Ben Statement',
  'SASSA Ben Enq',
  'SASSA-Other',
  'Independent Doc',
  'SASSA Affidavit',
  'Client Selfie',
  'SAFPS Npr Enquiry',
  'SAFPS NIIS Enquiry',
  'Mandate Indemnity',
  'Client ID Front',
  'Client ID Back',
  'VISA',
  'Mafori Salary',
  'Mafori Replace',
  'Privacy Policy',
  // 'Account Pack' = 1,
  // 'Shamwari Check',
  // 'Account Package Card Replacement',
  // 'Proof of Address',
  // 'Proof of Income',
  // 'Application',
  // 'PEP & Terrorist Check',
  // 'Application Bus',
  // 'Client ID',
  // 'Termination of Free Funeral Cover',
  // 'Application T&C',
  // 'SureCard Account Classification Upgrade',
  // 'Work Permit',
  // 'Asylum Seeker Permi',
  // 'DHA Check',
  // 'CellBank Service Application',
  // 'Temporary ID',
  // 'Temporary Passport',
  // 'Birth Certificate',
  // 'Bookkeeper Letter',
  // 'Passport',
  // 'Unknown',
  // 'Card Replacement',
  // 'Card Signature',
  // 'CIPC Check',
  // 'CIPC Reg Ver',
  // 'CK 1',
  // 'CK 2',
  // 'Client Interview',
  // 'Funeral Benefit Application',
  // 'Funeral Policy Certificate',
  // 'World Check Bus',
  // 'Salary Instruction',
  // 'Clients ID',
  // 'Dormancy React',
  // 'Tax Clear Cert',
  // 'PEP & Terrorist Perv',
  // 'ID Verification',
  // 'Historic Document',
  // 'ID Bus Client',
  // 'Indemnity Form',
  // 'Proof of Bus Add',
  // 'KYC Business',
  // 'Letter of Authority',
  // 'Proof of Res Bus',
  // 'Limit Increase Bus',
  // 'Memo Inc COR15.1A',
  // 'Mobile Banking Serv',
  // 'Reg Cert COR14.3',
  // 'Notice Inc COR14.1',
  // 'Terms and Conditions',
  // 'Online Banking App',
  // 'Trust Deed',
  // 'Passport Check',
  // 'PEP Report Form',
  // 'Refugee Status Perm',
  // 'VAT Document'
}

export namespace enumDLIDocumentDescription {
  export function values() {
    return Object.keys(enumDLIDocumentDescription).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
